package features.timeoff.ui.modals

import kotlinx.html.*
import kotlinx.html.dom.append
import kotlinx.html.js.onClickFunction
import org.w3c.dom.HTMLElement
import shared.ui.ModalManager

object RequestTimeOffModal {
    fun render(root: HTMLElement) {
        root.append {
            div("modal-content fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-dark-800 border border-dark-700 rounded-2xl p-6 w-full max-w-md z-[101] hidden shadow-2xl scale-95 opacity-0 transition-all duration-300") {
                id = "request-timeoff-modal"
                
                div("flex justify-between items-center mb-6") {
                    h3("text-xl font-bold") { +"Request Time Off" }
                    button(classes = "text-slate-400 hover:text-white") {
                        onClickFunction = { ModalManager.close() }
                        +"✕"
                    }
                }
                
                div("space-y-4 mb-6") {
                    div {
                        label("block text-sm text-slate-400 mb-1") { +"Leave Type" }
                        select("w-full bg-dark-900 border border-dark-700 rounded-xl p-3 focus:outline-none focus:border-brand-cyan text-white") {
                            id = "timeoff-category-input"
                            // Will be populated dynamically from leaveCategories
                        }
                    }
                    div("grid grid-cols-2 gap-4") {
                        div {
                            label("block text-sm text-slate-400 mb-1") { +"Start Date" }
                            input(type = InputType.date, classes = "w-full bg-dark-900 border border-dark-700 rounded-xl p-3 focus:outline-none focus:border-brand-cyan text-white") {
                                id = "timeoff-start-input"
                                attributes["onchange"] = "updateTimeOffDays()"
                            }
                        }
                        div {
                            label("block text-sm text-slate-400 mb-1") { +"End Date" }
                            input(type = InputType.date, classes = "w-full bg-dark-900 border border-dark-700 rounded-xl p-3 focus:outline-none focus:border-brand-cyan text-white") {
                                id = "timeoff-end-input"
                                attributes["onchange"] = "updateTimeOffDays()"
                            }
                        }
                    }
                    // Days display
                    div("text-center py-2") {
                        id = "timeoff-days-display"
                        span("text-slate-400 text-sm") { +"Select dates to calculate days" }
                    }
                    div {
                        label("block text-sm text-slate-400 mb-1") { +"Reason" }
                        textArea(classes = "w-full bg-dark-900 border border-dark-700 rounded-xl p-3 focus:outline-none focus:border-brand-cyan text-white resize-none h-24") {
                            id = "timeoff-reason-input"
                            placeholder = "Reason for leave..."
                        }
                    }
                }
                
                button(classes = "w-full py-3 rounded-xl bg-brand-cyan text-white font-bold hover:bg-brand-green transition shadow-lg shadow-cyan-500/20") {
                    onClickFunction = { js("submitTimeOffRequest")() }
                    +"Submit Request"
                }
            }
        }
    }
}
